export * from './customer-edit.component';
export * from './customer-edit.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer-edit/index.ts